import RaffleService from '../../services/RaffleService';
import style from './styles/BlurredBackground.scss';

const BlurredBackground = ({ raffle }) => (
	raffle === null ? null : (
		<div className={style['blurred-background']}>
			<div style={`background-image: url("${RaffleService.getImageUrl(raffle.getMainImage())}")`} />
		</div>
	)
);

export default BlurredBackground;



// WEBPACK FOOTER //
// ./components/raffle/BlurredBackground.js